import { List, Record } from 'immutable'
import { AttachmentSizes, IAttachmentSizes } from './AttachmentSizes'
import { AttachmentType, ImageSize } from './enums'

export interface IAttachment {
  attachedTo: List<string>
  availableSizes?: IAttachmentSizes
  baseStorageUrl: string
  creator: string
  dateCreated: number
  dateUpdated: number
  description?: string
  extension: string
  fileName: string
  getImageUrl: (size: ImageSize) => string
  getUrl: () => string
  getLocalUrl: () => string
  id: string
  isPublic: boolean
  mimeType: string
  photoOf?: string
  tags: List<string>
  title: string
  type: AttachmentType
}

const AttachmentRecord = Record({
  attachedTo: List<string>(),
  availableSizes: undefined,
  baseStorageUrl: '',
  creator: '',
  dateCreated: 0,
  dateUpdated: 0,
  description: undefined,
  extension: '',
  fileName: '',
  id: '',
  isPublic: false,
  mimeType: '',
  photoOf: undefined,
  tags: List<string>(),
  title: '',
  type: 'NotSpecified',
})

export class Attachment extends AttachmentRecord implements IAttachment {
  public static fromJS(initialState?: Partial<IAttachment>) {
    if (!initialState) {
      return new Attachment()
    }

    const { attachedTo, availableSizes, tags, ...rest } = initialState
    return new Attachment({
      attachedTo: List(attachedTo || []),
      availableSizes: AttachmentSizes.fromJS(availableSizes),
      tags: List(tags || []),
      ...rest,
    })
  }

  public readonly attachedTo: List<string>
  public readonly availableSizes?: AttachmentSizes
  public readonly baseStorageUrl: string
  public readonly creator: string
  public readonly dateCreated: number
  public readonly dateUpdated: number
  public readonly description?: string
  public readonly extension: string
  public readonly fileName: string
  public readonly id: string
  public readonly isPublic: boolean
  public readonly mimeType: string
  public readonly photoOf?: string
  public readonly tags: List<string>
  public readonly title: string
  public readonly type: AttachmentType

  constructor(initialState?: Partial<Attachment>) {
    initialState ? super(initialState) : super()
  }

  public getImageUrl(size: ImageSize): string {
    if (!this.availableSizes) {
      return this.getUrl()
    }

    const availableSizes: any = this.availableSizes

    return availableSizes[size] !== undefined
      ? `${this.baseStorageUrl}/${availableSizes[size]}`
      : this.getUrl()
  }

  public getUrl(): string {
    return `${this.baseStorageUrl}/${this.id}${this.extension}`
  }

  public getLocalUrl(): string {
    return `/api/Files/${this.id}/Download`
  }
}
